<form class="change-password-form" [formGroup]="changePasswordDatas">
  <inputb3 formControlName="oldPassword" extraClass="profileInputs" fErrorText="{{ 'Required' | t }}" fPlaceholder="{{ 'OldPassword' | t }}" fInputType="password"></inputb3>
  <inputb3
    formControlName="newPassword"
    extraClass="profileInputs"
    fErrorText="{{ 'Register_Password_Info' | t }}"
    fPlaceholder="{{ 'NewPassword' | t }}"
    fInputType="password"></inputb3>
  <inputb3
    formControlName="reNewPassword"
    extraClass="profileInputs"
    fErrorText="{{ 'Register_Re_Password_Same_Error' | t }}"
    fPlaceholder="{{ 'NewRePassword' | t }}"
    fInputType="password"></inputb3>
</form>
<div class="btn colored blue btn-opacity login-dropdown-btn" *ngIf="changePasswordDatas.status !== 'VALID'">
  <div class="change-password-text">{{ 'ChangePassword' | t }}</div>
</div>
<div class="btn colored blue login-dropdown-btn" *ngIf="changePasswordDatas.status === 'VALID'" (click)="submitChangePasswordData()">
  <div class="change-password-text">{{ 'ChangePassword' | t }}</div>
</div>
<div class="userSettingPages" *ngIf="false">
  <div class="headerDecs">
    <h2>{{ 'ChangePassword' | t }}</h2>
    <span>{{ 'ChangePasswordDesc' | t }}</span>
  </div>

  <form class="example-form" [formGroup]="changePasswordDatas">
    <mat-form-field class="example-full-width">
      <input matInput placeholder="{{ 'OldPassword' | t }}" formControlName="oldPassword" type="password" />
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <input matInput placeholder="{{ 'NewPassword' | t }}" formControlName="newPassword" type="password" />
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <input matInput placeholder="{{ 'NewRePassword' | t }}" formControlName="reNewPassword" type="password" />
    </mat-form-field>
  </form>

  <div>
    <button mat-raised-button class="forgot-password-submit-button" (click)="submitChangePasswordData()" [disabled]="!changePasswordDatas.valid">{{ 'ChangePassword' | t }}</button>
  </div>
</div>
